export const tooltipStyle = {
  position: 'absolute',
  padding: '4px',
  background: 'rgba(0, 0, 0, 0.8)',
  color: '#fff',
  maxWidth: '300px',
  fontSize: '10px',
  zIndex: 9,
  pointerEvents: 'none'
};

export const layerControl = {
  borderRadius: 3,
  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
  fontFamily: 'ff-clan-web-pro, "Helvetica Neue", Helvetica, sans-serif !important',
  fontSize: '12px',
  lineHeight: 1.833,
  width: 200,
  position: 'absolute',
  top: '20px',
  right: '20px',
  padding: '20px',
  zIndex: 100,
  background: 'white'
};

export const inputRange = {
  width: '100%'
};

export const charts = {
  background: 'white',
  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
  fontFamily: 'ff-clan-web-pro, "Helvetica Neue", Helvetica, sans-serif !important',
  fontSize: '12px',
  lineHeight: 1.833,
  height: '100%',
  padding: '15px',
  position: 'absolute',
  left: 0,
  top: 0,
  width: 320,
  zIndex: 100
};



// WEBPACK FOOTER //
// ./src/style.js